/* eslint-disable react-hooks/exhaustive-deps */
import { ReactNode, useEffect, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row } from 'react-bootstrap';
import { ModalCrud } from "components/modal/modal-crud-component";
import { EntityField } from "../../@types/entity/field/crud/field-crud-entity"
import CreateTableCrud from 'components/table/table-crud-component';
import CreateFieldModalCrud from "components/field/field-modal-component";
import { Footer } from 'components/footer/footer-component';
import { TableHeaderFixedStyled } from "pages/style/table/table-header-fixed-styled";
import { SelectCompanie } from 'components/select/companie-select-component';
import { SelectOptionInterface } from '../../@types/entity/interface/select-option-interface'
import { TitleGroupComponent } from '../../components/title/title-group-component';
import { RestUseCase } from "../../service/api/rest/rest-usecase";
import { UseAlert } from "../../hook/alert-hook";
import { UseAuth } from "../../hook/auth-hook";

type PropsCrud = {
    titlePage: string;
    entityFields: EntityField[];
    updateEntity?: any;
    valueId?: string;

    filterByCompany?: boolean;
    modelCompany?: SelectOptionInterface;
    handleSelectProvider?: (filial: {
        value: number;
        label: string
    }) => any;

    getAll: () => any;
    getById?: (id: number, model?: any) => any;
    post?: (model: any) => any;
    patch?: (id: number, model: any) => any;
    put?: (id: number, model: any) => any;
    del?: (id: number) => any;
    carregarTiposObservacao?: () => any;
    tableHeader: any[];
    tableBody: any[];

    children?: {
        filterTable?: ReactNode;
        pagination?: ReactNode;
        nevigation?: ReactNode;
    };

    readonly?: boolean;
};

const ItemNotePage: React.FC<PropsCrud> = ({
    titlePage,
    entityFields,
    valueId,
    getAll,
    getById,
    post,
    patch,
    put,
    del,
    carregarTiposObservacao,
    tableHeader,
    tableBody,
    children,
    updateEntity,
    filterByCompany,
    handleSelectProvider,
    modelCompany,
    readonly = false,
}: PropsCrud) => {
    const valueIdCrud = valueId ? valueId : 'id';

    const [inEditing, updateInEditing] = useState<boolean>(true);

    const [showModalCrud, updateShowModalCrud] = useState<boolean>(false);
    const [showSecondModal, setShowSecondModal] = useState<boolean>(false);
    const [observationType, setObservationType] = useState<string>('');
    const [observationList, setObservationList] = useState<Array<{
        id: number,
        information: string,
        fixo: boolean
    }>>([]);
    const [editingObservationId, setEditingObservationId] = useState<number | null>(null);
    const [isLoadingObservations, setIsLoadingObservations] = useState<boolean>(false);
    const { loggedUserData } = UseAuth();

    const { showAlert } = UseAlert();

    const openModalCrud = () => {
        carregarTiposObservacao?.();
        updateShowModalCrud(true);
    };
    const closeModalCrud = () => {
        updateShowModalCrud(false);
        listAll();
    };

    const openSecondModal = () => {
        setShowSecondModal(true);
        fetchObservationTypes();
    };
    const closeSecondModal = () => {
        setShowSecondModal(false);
        carregarTiposObservacao?.();
        updateEntity(entityFields);
    };

    const changeField = (modelFields: any) => {
        const updatedFields = modelFields.map((field: any) => {
            const existingField = entityFields.find(f => f.name === field.name);
            return {
                ...field,
                listValueField: existingField?.listValueField || field.listValueField
            };
        });
        updateEntity(updatedFields);
    };

    const searchEntityId = () => {
        return entityFields.filter((value) => value.name === valueIdCrud)[0]
            .valueField as number;
    };

    const onSubmitForm = async () => {
        var model: any = {};
        entityFields.forEach((value) => {
            model[value.name] = value.valueField;
        });

        if (inEditing) await update(model, searchEntityId());
        if (!inEditing) await create(model);

        closeModalCrud();
    };

    const onClickTable = async (id: any, model?: any) => {
        updateInEditing(true);
        await listById(id, model);
        openModalCrud();
    };

    const onClickNew = () => {
        updateInEditing(false);
        clearFields();
    };

    const clearFields = () => {
        updateEntity(
            entityFields.map((value) => {
                value.valueField = '';
                return value;
            }),
        );
    };

    const listAll = async () => {
        await getAll();
    };
    const listById = async (id: any, model?: any) => {
        if (getById) await getById(id, model);
    };
    const create = async (model: any) => {
        if (post) await post(model);
    };
    const remove = async () => {
        if (del) await del(searchEntityId());
        closeModalCrud();
    };
    const update = async (model: any, id: number) => {
        if (put) await put(id, model);
        if (patch) await patch(id, model);
    };

    const fetchObservationTypes = async () => {
        let companyId = modelCompany?.value || loggedUserData?.companyId;

        setIsLoadingObservations(true);
        try {
            const idsToExclude = [4, 5, 6];
            const queryParams = idsToExclude.map(id => `excluirIds=${id}`).join('&');
            const url = `/configuracao/${companyId}/tipos-observacao${queryParams ? `?${queryParams}` : ''}`;

            const response = await new RestUseCase(url).Get().finally();

            if (response.body) {
                const mappedData = response.body.map((item: any) => ({
                    id: item.id,
                    information: item.descricao,
                    fixo: item.fixo
                }));

                // Ordena a lista: fixos primeiro, depois não fixos
                const sortedData = mappedData.sort((a: { fixo: boolean }, b: { fixo: boolean }) => {
                    if (a.fixo === b.fixo) return 0;
                    return a.fixo ? -1 : 1;
                });

                setObservationList(sortedData);
            }
        } catch (error) {
            console.error('Erro ao carregar tipos de observação:', error);
        } finally {
            setIsLoadingObservations(false);
        }
    };

    useEffect(() => {
        fetchObservationTypes();
    }, [modelCompany?.value]);

    const handleAddObservation = async () => {
        let companyId = modelCompany?.value || loggedUserData?.companyId;

        try {
            if (editingObservationId !== null) {
                const response = await new RestUseCase(`/configuracao/${companyId}/tipos-observacao/${editingObservationId}`)
                    .Put({
                        data: {
                            descricao: observationType,
                            idEmpresa: companyId
                        }
                    });

                if (response.statusCode === 204) {
                    showAlert({
                        show: true,
                        content: 'Tipo de observação atualizado com sucesso!',
                        color: 'success',
                        time: 2000,
                    });
                    await fetchObservationTypes();
                    setObservationType('');
                    setEditingObservationId(null);
                } else {
                    showAlert({
                        show: true,
                        content: 'Erro ao atualizar tipo de observação.',
                        color: 'danger',
                        time: 2000,
                    });
                }
            } else {
                const response = await new RestUseCase(`/configuracao/${companyId}/tipos-observacao`).Post({
                    data: {
                        descricao: observationType,
                        idEmpresa: companyId
                    }
                });

                if (response.statusCode === 201) {
                    showAlert({
                        show: true,
                        content: 'Tipo de observação criado com sucesso!',
                        color: 'success',
                        time: 2000,
                    });
                    await fetchObservationTypes();
                    setObservationType('');
                    setEditingObservationId(null);
                } else {
                    showAlert({
                        show: true,
                        content: 'Erro ao criar tipo de observação.',
                        color: 'danger',
                        time: 2000,
                    });
                }
            }
        } catch (error) {
            showAlert({
                show: true,
                content: 'Erro ao processar operação.',
                color: 'danger',
                time: 2000,
            });
        }
    };

    const handleEditObservation = (id: number) => {
        const observation = observationList.find(item => item.id === id);
        if (observation) {
            setObservationType(observation.information);
            setEditingObservationId(id);
        }
    };

    const handleRemoveObservation = async (id: number) => {
        let companyId = modelCompany?.value || loggedUserData?.companyId;

        const response = await new RestUseCase(`/configuracao/${companyId}/tipos-observacao/${id}`)
            .Delete();

        if (response.statusCode === 204) {
            showAlert({
                show: true,
                content: 'Tipo de observação excluído com sucesso!',
                color: 'success',
                time: 2000,
            });

            await fetchObservationTypes();
        } else {
            if (response.statusCode === 400) {
                showAlert({
                    show: true,
                    content: 'Não é possível remover este tipo de observação pois ele está em uso.',
                    color: 'danger',
                    time: 2000,
                });
            } else {
                showAlert({
                    show: true,
                    content: 'Erro ao excluir tipo de observação.',
                    color: 'danger',
                    time: 2000,
                });
            }
        }
    };

    function CreateSelectCompany() {
        return (
            <div className='m-2'>
                <Row className='d-flex align-items-center justify-content-start'>
                    <Col md={1}>
                        <Form.Label>Empresa:</Form.Label>
                    </Col>
                    <Col md={3}>
                        <SelectCompanie
                            passOnTheValue={handleSelectProvider}
                            defaultValue={modelCompany}
                        />
                    </Col>
                </Row>
            </div>
        );
    }

    useEffect(() => {
        if (filterByCompany === undefined || filterByCompany === false) {
            listAll();
        }
    }, []);

    return (
        <>
            <div className='mx-5'>
                <TitleGroupComponent titlePage={titlePage}>
                    <Row>
                        <Col className='d-flex align-items-center justify-content-end'>
                            {post ? (
                                <Button
                                    size='sm'
                                    variant='primary'
                                    onClick={() => {
                                        openModalCrud();
                                        onClickNew();
                                    }}
                                >
                                    Novo
                                </Button>
                            ) : (
                                <></>
                            )}
                        </Col>
                    </Row>
                </TitleGroupComponent>
            </div>
            {filterByCompany === true && <CreateSelectCompany />}
            <div className='mx-2'>
                <Card>
                    <Card.Body>
                        {children?.filterTable ? (
                            <>{children?.filterTable}</>
                        ) : (
                            <></>
                        )}

                        {children?.nevigation ? (
                            <>{children?.nevigation}</>
                        ) : (
                            <></>
                        )}
                        {tableBody.length > 0 ? (
                            <>
                                <div className='mt-1 '>
                                    <TableHeaderFixedStyled>
                                        <CreateTableCrud
                                            tableHeader={tableHeader}
                                            tableBody={tableBody}
                                            entityFields={entityFields}
                                            openModalCrud={onClickTable}
                                            valueId={valueIdCrud}
                                        />
                                    </TableHeaderFixedStyled>
                                </div>
                            </>
                        ) : (
                            <>
                                <div
                                    className='d-flex align-items-center justify-content-center'
                                    style={{ height: '60vh' }}
                                >
                                    verifique seus paramentros de busca...
                                </div>
                            </>
                        )}

                        {children?.pagination ? (
                            <>{children?.pagination}</>
                        ) : (
                            <></>
                        )}
                    </Card.Body>
                </Card>
            </div>
            <Footer />
            {getById ? (
                <>
                    <ModalCrud
                        title={titlePage}
                        open={openModalCrud}
                        close={closeModalCrud}
                        isOpen={showModalCrud}
                        isEditing={inEditing}
                        submit={onSubmitForm}
                    >
                        <div>
                            <CreateFieldModalCrud
                                entityFields={entityFields}
                                changeField={changeField}
                                inEditing={inEditing}
                            />
                            {entityFields.map((field, index) => {
                                if (field.name === 'idTipoObservacao') {
                                    return (
                                        <div key={index} style={{
                                            position: 'relative',
                                            top: '-32px',
                                            left: 'calc(91.66% - 10px)',
                                            width: 'fit-content',
                                            marginBottom: '-32px'
                                        }}>
                                            <Button
                                                variant='primary'
                                                size='sm'
                                                onClick={openSecondModal}
                                                style={{
                                                    minWidth: '32px',
                                                    height: '32px',
                                                    marginLeft: '15px',
                                                    marginTop: '-380px'
                                                }}
                                            >
                                                +
                                            </Button>
                                        </div>
                                    );
                                }
                                return null;
                            })}
                        </div>
                        {readonly === false && (
                            <div>
                                {inEditing ? (
                                    put || patch ? (
                                        <Button
                                            variant='primary'
                                            size='sm'
                                            type='submit'
                                        >
                                            Salvar Edição
                                        </Button>
                                    ) : (
                                        <></>
                                    )
                                ) : (
                                    <Button
                                        variant='primary'
                                        size='sm'
                                        type='submit'
                                    >
                                        Salvar
                                    </Button>
                                )}
                                <Button
                                    className='ms-1'
                                    variant='outline-primary'
                                    size='sm'
                                    onClick={clearFields}
                                >
                                    Limpar
                                </Button>
                                {inEditing ? (
                                    del ? (
                                        <Button
                                            className='ms-1'
                                            variant='danger'
                                            size='sm'
                                            onClick={remove}
                                        >
                                            Deletar
                                        </Button>
                                    ) : (
                                        <></>
                                    )
                                ) : (
                                    <></>
                                )}
                            </div>
                        )}

                        <div>
                            <p>Validações: </p>
                        </div>
                    </ModalCrud>

                    <Modal show={showSecondModal} onHide={() => closeSecondModal()} size={"lg"}
                        fullscreen={"md-down"}>
                        <Modal.Header closeButton>
                            <Modal.Title className="ms-3 lead" style={{ fontSize: "30px" }}>
                                Cadastro Tipo de Observação
                            </Modal.Title>
                        </Modal.Header>
                        <form onSubmit={(e) => {
                            e.preventDefault();
                            handleAddObservation();
                        }}
                            className="mt-0"
                            noValidate
                        >
                            <Modal.Body>
                                <div className="mb-3">
                                    <Row>
                                        <Col md={10}>
                                            <Form.Control
                                                type="text"
                                                placeholder="Tipo de observação"
                                                value={observationType}
                                                onChange={(e) => setObservationType(e.target.value)}
                                            />
                                        </Col>
                                        <Col md={2}>
                                            <Button
                                                variant='primary'
                                                size='sm'
                                                onClick={handleAddObservation}
                                                disabled={!observationType.trim() || isLoadingObservations}
                                            >
                                                {editingObservationId !== null ? 'Salvar' : 'Incluir'}
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>

                                <TableHeaderFixedStyled>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Informação</th>
                                                <th style={{ width: '150px' }}>Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {isLoadingObservations ? (
                                                <tr>
                                                    <td colSpan={2} className="text-center">Carregando...</td>
                                                </tr>
                                            ) : observationList.length === 0 ? (
                                                <tr>
                                                    <td colSpan={2} className="text-center">Nenhum tipo de observação
                                                        cadastrado
                                                    </td>
                                                </tr>
                                            ) : (
                                                observationList.map((item) => (
                                                    <tr key={item.id}>
                                                        <td>{item.information}</td>
                                                        <td>
                                                            {!item.fixo && (
                                                                <>
                                                                    <Button
                                                                        variant='primary'
                                                                        size='sm'
                                                                        className="me-1"
                                                                        onClick={() => handleEditObservation(item.id)}
                                                                    >
                                                                        Editar
                                                                    </Button>
                                                                    <Button
                                                                        variant='danger'
                                                                        size='sm'
                                                                        onClick={() => handleRemoveObservation(item.id)}
                                                                    >
                                                                        Excluir
                                                                    </Button>
                                                                </>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </TableHeaderFixedStyled>
                            </Modal.Body>
                        </form>
                    </Modal>
                </>
            ) : (
                <></>
            )}
        </>
    );
};

export default ItemNotePage;